import { DSFormControl, DSInputLabel, DSMenuItem, DSSelect, Translate } from '@deltasierra/components';
import { t, timezones } from '@deltasierra/shared';
import * as React from 'react';

export type TimezoneSelectProps = {
    onChange?: (timezone: string) => void;
    initialTimezone: string;
};

export function TimezoneSelect({ initialTimezone, onChange }: TimezoneSelectProps): JSX.Element {
    const timezoneOptions = React.useMemo(() => timezones.map(({ keyId, value }) => ({ label: t(keyId), value })), []);
    const [timezone, setTimezone] = React.useState(initialTimezone);

    return (
        <DSFormControl fullWidth>
            <DSInputLabel id="timezone-select-label" shrink>
                <Translate keyId="COMMON.TIMEZONE" />
            </DSInputLabel>
            <DSSelect
                id="timezone-select"
                labelId="timezone-select-label"
                value={timezone}
                onChange={event => {
                    setTimezone(event.target.value as string);
                    onChange?.(event.target.value as string);
                }}
            >
                {timezoneOptions.map(option => (
                    <DSMenuItem key={option.value} value={option.value}>
                        {option.label}
                    </DSMenuItem>
                ))}
            </DSSelect>
        </DSFormControl>
    );
}
TimezoneSelect.displayName = 'TimezoneSelect';
